import { createLogger, serializeError } from 'logging';

import { telemetryTimerAction } from './telemetry.actions';

const logger = createLogger('TelemetryTimer');

export class TelemetryTimer {
    public static start(telemetryTag: string): RunningTelemetryTimer {
        return new RunningTelemetryTimer(telemetryTag);
    }

    public constructor(public telemetryTag: string) {}

    public start(): RunningTelemetryTimer {
        return new RunningTelemetryTimer(this.telemetryTag);
    }
}

class RunningTelemetryTimer {
    private startTime: number;

    public constructor(public readonly telemetryTag: string) {
        this.startTime = Date.now();
    }

    public async stopAndSend(): Promise<void> {
        const duration = Date.now() - this.startTime;
        try {
            await telemetryTimerAction(this.telemetryTag, duration);
        } catch (err) {
            logger.error({ err: serializeError(err) }, 'Failed to send telemetry timer event');
        }
    }
}
